import React from "react";
import {
	Flex,
	Spin,
	Table,
	DatePicker,
	Input,
	Select,
	Row,
	Col,
	Typography,
} from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const { Search } = Input;
const { Text } = Typography;

const CustomTable = ({ columns, data, isScroll = true, loading = false }) => {
	return (
		<Table
			columns={columns}
			dataSource={data}
			pagination={{
				position: ["bottomRight"],
				pageSizeOptions: [10, 20, 50, 100, 250, 500],
				defaultPageSize: 10,
				showSizeChanger: true,
			}}
			scroll={{
				x: isScroll ? 1300 : true,
			}}
			style={{
				minWidth: "100%",
			}}
			loading={loading}
		/>
	);
};

const CustomPicker = ({
	label,
	onChange,
	options,
	loading,
	defaultValue,
	width,
	isMulti,
	value,
	allowClear,
	disabled = false,
}) => {
	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	return (
		<Select
			showSearch
			placeholder={`Select ${label}`}
			optionFilterProp="children"
			size="large"
			onChange={onChange}
			filterOption={filterOption}
			options={options}
			disabled={loading || disabled}
			defaultValue={defaultValue}
			value={value}
			mode={isMulti ? "multiple" : undefined}
			style={{
				width: width,
			}}
			allowClear={allowClear}
		/>
	);
};

const CustomSearch = ({
	startDate,
	endDate,
	dateFormat,
	onRangeChange,
	onDateChange,
	onSearch,
	loading,
	labelPicker,
	optionsPicker,
	onChangePicker,
	defaultValuePicker,
	pickerWidth = "100%",
	isMulti = false,
	pickerValue,
	allowClearDate = true,
	allowClearPicker = false,
	disabledPicker = false,
	labelPicker2,
	optionsPicker2,
	onChangePicker2,
	defaultValuePicker2,
	pickerWidth2 = "100%",
	isMulti2 = false,
	pickerValue2,
	allowClearPicker2 = false,
	disabledPicker2 = false,
	labelPicker3,
	optionsPicker3,
	onChangePicker3,
	defaultValuePicker3,
	pickerWidth3 = "100%",
	isMulti3 = false,
	pickerValue3,
	allowClearPicker3 = false,
	disabledPicker3 = false,
	pickerTitle,
	pickerTitle2,
	pickerTitle3,
}) => {
	return (
		// <Flex gap={"middle"} align="end">
		<Row gutter={16} align={"bottom"} style={{ width: "80%" }}>
			{
				/**
				 *? Range Date Picker
				 */
				startDate && endDate && (
					<Col span={6}>
						<Row>
							<Col span={24}>
								<Text>Dates</Text>
							</Col>
							<Col span={24}>
								<RangePicker
									defaultValue={[
										dayjs(startDate, dateFormat),
										dayjs(endDate, dateFormat),
									]}
									onChange={onRangeChange}
									format={dateFormat}
									size="large"
									disabled={loading}
									allowClear={false}
									style={{ width: "100%" }}
								/>
							</Col>
						</Row>
					</Col>
				)
			}
			{
				/**
				 *? Single Date Picker
				 */
				startDate && !endDate && (
					<Col span={6}>
						<DatePicker
							defaultValue={dayjs(startDate)}
							onChange={onDateChange}
							format={dateFormat}
							disabled={loading}
							allowClear={allowClearDate}
							style={{ width: "100%" }}
							size="large"
						/>
					</Col>
				)
			}
			{
				/**
				 *? Custom Picker
				 */
				optionsPicker && labelPicker && onChangePicker && (
					<Col span={6}>
						<Row>
							{pickerTitle && (
								<Col span={24}>
									<Text>{pickerTitle}</Text>
								</Col>
							)}
							<Col span={24}>
								<CustomPicker
									label={labelPicker}
									options={optionsPicker}
									onChange={onChangePicker}
									loading={loading}
									defaultValue={defaultValuePicker}
									width={pickerWidth}
									isMulti={isMulti}
									value={pickerValue}
									allowClear={allowClearPicker}
									disabled={disabledPicker}
								/>
							</Col>
						</Row>
					</Col>
				)
			}
			{
				/**
				 *? Custom Picker 2
				 */
				optionsPicker2 && labelPicker2 && onChangePicker2 && (
					<Col span={6}>
						<Row>
							{pickerTitle2 && (
								<Col span={24}>
									<Text>{pickerTitle2}</Text>
								</Col>
							)}
							<Col span={24}>
								<CustomPicker
									label={labelPicker2}
									options={optionsPicker2}
									onChange={onChangePicker2}
									loading={loading}
									defaultValue={defaultValuePicker2}
									width={pickerWidth2}
									isMulti={isMulti2}
									value={pickerValue2}
									allowClear={allowClearPicker2}
									disabled={disabledPicker2}
								/>
							</Col>
						</Row>
					</Col>
				)
			}
			{
				/**
				 *? Custom Picker 3
				 */
				optionsPicker3 && labelPicker3 && onChangePicker3 && (
					<Col span={6}>
						<Row>
							{pickerTitle3 && (
								<Col span={24}>
									<Text>{pickerTitle3}</Text>
								</Col>
							)}
							<Col span={24}>
								<CustomPicker
									label={labelPicker3}
									options={optionsPicker3}
									onChange={onChangePicker3}
									loading={loading}
									defaultValue={defaultValuePicker3}
									width={pickerWidth3}
									isMulti={isMulti3}
									value={pickerValue3}
									allowClear={allowClearPicker3}
									disabled={disabledPicker3}
								/>
							</Col>
						</Row>
					</Col>
				)
			}
			{
				/**
				 *? Search input
				 */
				onSearch != null && (
					<Col span={6}>
						<Search
							placeholder="Search"
							enterButton
							onSearch={onSearch}
							allowClear
							style={{
								width: "100%",
								// width: 400,
							}}
							size="large"
							loading={loading}
							disabled={loading}
						/>
					</Col>
				)
			}
		</Row>
	);
};

const CustomSpinner = () => {
	return (
		<div
			style={{
				margin: "20px 0",
				marginBottom: "20px",
				padding: "50px 50px",
				textAlign: "center",
			}}
		>
			<Spin size="large" />
		</div>
	);
};

export { CustomTable, CustomSpinner, CustomSearch, CustomPicker };
